import { render, staticRenderFns } from "./service-azc.vue?vue&type=template&id=85629092&scoped=true"
import script from "./service-azc.vue?vue&type=script&lang=js"
export * from "./service-azc.vue?vue&type=script&lang=js"
import style0 from "./service-azc.vue?vue&type=style&index=0&id=85629092&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85629092",
  null
  
)

export default component.exports